import React from 'react';
import css from './css/BuildSurveyElementsContainer.scss';
import commonCss from './css/SurveyStyle.scss';
import classnames from 'classnames';
import Element from './Element';
import ElementDragDropContext from './ElementDragDropContext';
import DroppableRegion from './DroppableRegion';
import { Draggable } from 'react-beautiful-dnd';
import { getWord } from 'utils/tenant';
import { StudentSurveyElement } from 'utils/types';
import { sortBy } from 'lodash';
import PropTypes from 'prop-types';

const BuildSurveyElementsContainer = ({title, surveyElements, editable, onEdit, onDelete, onReorder}) => {
    const studentSurveyCustomLanguage = getWord('studentSurvey', false);

    const getEmptyState = () => (
        <div className={css['empty-instructions']}>
            <div className={commonCss['header-second-level']}>
                This {studentSurveyCustomLanguage} is empty. You must add at least one question to schedule the {studentSurveyCustomLanguage}.
            </div>
            <img src='../images/starfish/build_starfish.png' aria-hidden='true' className={css['build-starfish']}/>
        </div>
    );

    const displayText = (element) => element.elementType === 'QUESTION' ? element.templateQuestion.questionText : element.elementText;

    const getElements = () => (
        <ElementDragDropContext elements={surveyElements} setElements={onReorder}>
            <DroppableRegion droppableId='droppable-1'>
                {sortBy(surveyElements, 'elementPosition').map((element, index) => (
                    <Draggable key={element.id} draggableId={`element-${element.id}`} index={index} isDragDisabled={!editable}>
                        {(provided, snapshot) => (
                            <div ref={provided.innerRef}
                                 {...provided.draggableProps}
                                 {...provided.dragHandleProps}
                                 aria-label={`${displayText(element)}, position ${index + 1} of ${surveyElements.length}`}
                                 className={classnames(`${editable ? [css['element']] : [css['disabled-element']]}`, {[css['dragging']]: snapshot.isDragging})}
                                 data-testid={`element-${element.elementPosition}`}
                            >
                                <Element surveyElement={element} editable={editable} onEdit={onEdit} onDelete={onDelete} />
                            </div>
                        )}
                    </Draggable>
                ))}
            </DroppableRegion>
        </ElementDragDropContext>
    );

    return (
        <div className={css['survey-container']}>
            <div className={css['survey-title']}>
                <span>{title}</span>
                <div className={css['question-required']}>
                    <span className={commonCss['required-asterisk']} aria-hidden>*</span> Question Is Required
                </div>
            </div>
            <div className={classnames(css['element-container'], {[css['empty']]: !surveyElements.length})}>
                {surveyElements.length > 0 ? getElements() : getEmptyState()}
            </div>
        </div>
    );
};

BuildSurveyElementsContainer.propTypes = {
    title: PropTypes.string.isRequired,
    surveyElements: PropTypes.arrayOf(StudentSurveyElement).isRequired,
    editable: PropTypes.bool.isRequired,
    onEdit: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    onReorder: PropTypes.func.isRequired
};

export default BuildSurveyElementsContainer;
